import React, { FC } from "react";
import { Container } from "../../../../components";
import { Icon } from "@telia/teddy";
import cn from "classnames";
import * as properNameCase from "../../../../../../shared/properNameCase";
import TEXT from "../../../text-consts";
import "./RegisteredMemberCard.less";

interface RegisteredMemberCardProps {
    isExisting: boolean;
    isInProcess?: boolean;
    name: string;
    onEdit?: () => void;
    title: string;
}

const RegisteredMemberCard: FC<RegisteredMemberCardProps> = ({ title, name, onEdit, isExisting, isInProcess }) => {
    return (
        <Container
            className={cn("registered-member-card", {
                "registered-member-card--existing": isExisting,
                "registered-member-card--in-process": isInProcess,
            })}
            size="small"
            whiteBg={!isExisting}
        >
            <div className="registered-member-card__info-wrapper">
                <div className="registered-member-card__info">
                    <Icon
                        name="checkmark"
                        className={cn("registered-member-card__checkmark", {
                            "registered-member-card__checkmark--existing": isExisting,
                        })}
                    />
                    <div className="registered-member-card__edit">
                        <span
                            className={cn("registered-member-card__title", {
                                "registered-member-card__title--existing": isExisting,
                            })}
                        >
                            {title}
                        </span>
                    </div>
                    <div
                        className={cn("registered-member-card__member", {
                            "registered-member-card__member--existing": isExisting,
                        })}
                        data-di-mask
                    >
                        <span data-di-mask className="registered-member-card__member__description">
                            {properNameCase.convert(name)}
                        </span>
                    </div>
                </div>
                {onEdit && (
                    <button
                        onClick={onEdit}
                        className="button button--small registered-member-card__button registered-member-card__edit"
                    >
                        <Icon name="edit" className="registered-member-card__edit__icon" />
                        <span className="registered-member-card__edit__text">{TEXT.COMMON.EDIT}</span>
                    </button>
                )}
                {isInProcess && <span className="registered-member-card__in-process">{TEXT.ADD_MEMBER.IN_ORDER}</span>}
            </div>
        </Container>
    );
};

export default RegisteredMemberCard;
